import React from "react";
import PropTypes from "prop-types";
import { Label } from "reactstrap";
import { Field, ErrorMessage } from "formik";

const RavenFormikTextAreaComp = ({
  name,
  label,
  maxLength,
  divClassName,
  getClassNameValue,
  disabled,
  placeholder,
  value,
  rows,
  onChange,
  handleOnChange,
}) => {
  return (
    <div id={name + "_div"} className={divClassName || "mb-3"}>
      <Label className="form-label">{label}</Label>
      <Field
        name={name}
        type="text"
        as="textarea"
        className={getClassNameValue}
        disabled={disabled}
        placeholder={placeholder}
        maxLength={maxLength}
        {...(value ? { value: value } : {})}
        {...(rows ? { rows: rows } : {})}
        {...(onChange ? { onChange: handleOnChange } : {})}
      />
      <ErrorMessage name={name} component="div" className="invalid-feedback" />
    </div>
  );
};

RavenFormikTextAreaComp.propTypes = {
  name: PropTypes.any,
  label: PropTypes.any,
  maxLength: PropTypes.any,
  divClassName: PropTypes.any,
  disabled: PropTypes.bool,
  placeholder: PropTypes.any,
  getClassNameValue: PropTypes.any,
  value: PropTypes.any,
  rows: PropTypes.any,
  onChange: PropTypes.any,
  handleOnChange: PropTypes.any,
};

export default RavenFormikTextAreaComp;
